import {
  Component,
  OnInit,
  Inject,
  Output,
  EventEmitter,
  ViewChild,
  Input,
  SimpleChanges,
} from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ApiCallService } from "src/app/core/services/api-call-service";
import { PopUpDialogService } from "src/app/core/services/pop-up-dialog.service";
import { TokenStorageService } from "src/app/core/auth/token-storage.service";
import { TranslateDynamicText } from "src/app/shared/pipes/dynamic-translation.pipe";
import { WidgetConfigService } from "src/app/core/services/widget-config.service";
import { SnackbarCollection } from "src/app/core/services/snackbar.service";
import { GetTimeBasedChallengeDetailsComponent } from "../get-time-based-challenge-details/get-time-based-challenge-details.component";
import { OfferBudgetComponent } from "src/app/shared/components/offer-budget/offer-budget.component";
import { ChallengesMilestoneDataService } from "src/app/core/services/challenges-milestone-data.service";
import { ChallengeData, usageConfig } from "src/app/shared/models/model";
import { Globals } from "src/app/core/services/global.service";
import { Editor, Toolbar } from "ngx-editor";
import { maxLengthHtml } from "src/app/shared/custom-validator";
import { Plugin, PluginKey } from "prosemirror-state";
import { Slice, Fragment } from "prosemirror-model";

@Component({
  selector: "app-get-challenge-details-page",
  templateUrl: "./get-challenge-details-page.component.html",
  styleUrls: [
    "./get-challenge-details-page.component.css",
    "../../../../../../shared/components/dialog-box/campaign-strategy-dialog/campaign-strategy-dialog.component.css",
  ],
})
export class GetChallengeDetailsPageComponent implements OnInit {
  merchantTrackingAction;
  merchantTrackingType;
  includeDropDownStatus: boolean = false;
  excludeDropDownStatus: boolean = true;
  customerSegments = [];
  excludedSegments = [];
  endDate = new FormControl(new Date());
  startDate = new FormControl(new Date());
  startDateMinValue = new Date();
  startDateMaxValue = new Date();
  endDateMinValue = new Date();
  endDateMaxValue = new Date();
  totalCustomerCount = 0;
  storeTargetedCustomerCount = 0;
  totalCustomersValidEmail = 0;
  totalCustomersValidPhNo = 0;
  createstrategyApi = null;
  allcustomerObj = [
    { id: "ALL", segmentName: "My Customers" },
    { id: "LEADS", segmentName: "All Leads" },
  ];
  dataForm = new FormGroup({
    name: new FormControl("", [
      Validators.required,
      Validators.minLength(3),
      Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),

      maxLengthHtml(50),
    ]),
    aliasName: new FormControl("", [
      Validators.minLength(3),
      Validators.pattern(/^[\p{L}\p{N}\s.,'"<>\-()!?/]+$/u),
      maxLengthHtml(50),
    ]),
    header: new FormControl("", [
      Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),
      maxLengthHtml(300),
    ]),
    customerSegments: new FormControl("", [Validators.required]),
    customerIds: new FormControl("", [Validators.required]),
    description: new FormControl("", [
      maxLengthHtml(300),
      Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),
    ]),
    aliasDescription: new FormControl("", [maxLengthHtml(300)]),
  });

  submitClicked = false;
  disableCustomerSegments = false;
  apiErrorMessage = null;
  segmentFilter = "";
  excludeSegmentFilter = "";
  store;
  adminCreated = {
    storeId: null,
    storeName: "ADMIN",
    qid: null,
    userName: this.tokenStorage.getUsernameFull(),
    userEmail: this.tokenStorage.getMerchantUserEmail(),
  };
  storeDataJSON = {};
  @Input() duplicateNameErrorText = "";
  validScreens;
  isAdmin = true;
  storeId;
  data: any = {};
  uploading1 = false;
  uploading2 = false;
  badgeImageUrl = "";
  bannerImageUrl = "";
  numberOfDays = 0;
  usageLimit = 1;
  rejoiningDays = 1;
  needsOptIn: boolean = false;
  timeFrameType = "CUSTOM";
  customerSegmentAndTiers = [];
  timeFrame = {};
  @Input() isEdit: boolean;
  @Input() status;
  @Output() challengeDetails = new EventEmitter<any>();
  @ViewChild("timeBasedData")
  timeBasedData: GetTimeBasedChallengeDetailsComponent;
  @ViewChild("offerBudgetData")
  offerBudgetData: OfferBudgetComponent;
  nameEditor: Editor;
  aliasNameEditor: Editor;
  headerEditor: Editor;
  descriptionEditor: Editor;
  aliasDescriptionEditor: Editor;
  html: "";
  toolbar: Toolbar = [["bold"]];

  constructor(
    private apiCallService: ApiCallService,
    private popUp: PopUpDialogService,
    private global: Globals,
    private tokenStorage: TokenStorageService,
    private _i18nDynamicTranslate: TranslateDynamicText,
    private _WidgetConfigService: WidgetConfigService,
    private _snackBar: SnackbarCollection,
    private challengeDataServie: ChallengesMilestoneDataService
  ) {
    window["screen-name"] = "CAMPAIGN CREATE";
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.duplicateNameErrorText);
    if (changes.rewardData) {
      console.log("testtt");
    }
  }

  async ngOnInit() {
    const blockImagePastePlugin = new Plugin({
      key: new PluginKey("blockImagePastePlugin"),
      props: {
        handlePaste(view, event) {
          const clipboardData = (event as ClipboardEvent).clipboardData;
          if (!clipboardData) return false;

          for (let i = 0; i < clipboardData.items.length; i++) {
            if (clipboardData.items[i].type.startsWith("image/")) {
              // Block image pasting
              event.preventDefault();
              return true; // Prevent paste from continuing
            }
          }

          return false; // allow non-image paste
        },
      },
    });

    const plainTextPastePlugin = new Plugin({
      key: new PluginKey("plainTextPastePlugin"),
      props: {
        handlePaste(view, event, _slice) {
          const clipboardData = (event as ClipboardEvent).clipboardData;
          if (!clipboardData) return false;

          const text = clipboardData.getData("text/plain");
          if (!text) return false;

          event.preventDefault();

          const { schema } = view.state;

          // Insert plain text as paragraph nodes
          const nodes = text
            .split(/\n{2,}/) // split by double newlines = paragraph
            .map((paragraphText) =>
              schema.nodes.paragraph.create(
                null,
                schema.text(paragraphText.trim())
              )
            );

          const slice = new Slice(Fragment.fromArray(nodes), 1, 1);
          const transaction = view.state.tr.replaceSelection(slice);
          view.dispatch(transaction);

          return true;
        },
      },
    });

    this.aliasNameEditor = new Editor({
      // Add your schema, history, etc. if needed
      content: "",
      plugins: [blockImagePastePlugin, plainTextPastePlugin],
    });
    this.nameEditor = new Editor({
      // Add your schema, history, etc. if needed
      content: "",
      plugins: [blockImagePastePlugin, plainTextPastePlugin],
    });
    this.headerEditor = new Editor({
      // Add your schema, history, etc. if needed
      content: "",
      plugins: [blockImagePastePlugin, plainTextPastePlugin],
    });
    this.aliasDescriptionEditor = new Editor({
      // Add your schema, history, etc. if needed
      content: "",
      plugins: [blockImagePastePlugin, plainTextPastePlugin],
    });
    this.descriptionEditor = new Editor({
      // Add your schema, history, etc. if needed
      content: "",
      plugins: [blockImagePastePlugin, plainTextPastePlugin],
    });
    await this.getSegments();
    await this.getDefaultConfig();
    this.storeId =
      this.tokenStorage.getqId() === "null" ? null : this.tokenStorage.getqId();
    if (this.tokenStorage.getqId() !== "null") {
      this.getParticularStoreJSON();
      this.isAdmin = false;
    }
    this.getScreenId();
    this.store = this.tokenStorage.getMerchantOnlineStore();
    this.startDateMinValue = this.startDate.value;
    this.endDateMinValue = this.startDate.value;
    this.startDateMaxValue = null;
    this.endDateMaxValue = null;
    this.merchantTrackingAction = "create";
    this.merchantTrackingType = "";
    if (this.merchantTrackingAction == "create") {
      window["screen-id"] = 6;
      this.merchantTrackingType = "custom";
    } else {
      window["screen-id"] = 8;
    }

    // if (this.data["operation"] === "UPDATE") {
    //   this.dataForm
    //     .get("name")
    //     .setValue(this.data["name"]);
    //   this.dataForm
    //     .get("description")
    //     .setValue(this.data["strategyDescription"]);
    //   this.totalCustomerCount = this.data["customerCount"];
    //   this.toggleDisabledValue();
    //   if (this.data["segments"].length > 0) {
    //     this.customerSegments = this.data["segments"].map((x) => x);
    //   }
    //   if (this.data["excludedSegments"].length > 0) {
    //     this.excludedSegments = this.data["excludedSegments"].map((x) => x);
    //   }
    //   if (this.data["allLead"] === true) {
    //     this.customerSegments.push("LEADS");
    //   }
    //   if (this.data["allCustomer"] === true) {
    //     this.customerSegments.push("ALL");
    //   }
    //   this.getCustomerCountInSegmentAndTiers();
    // }
    // if (this.data["recommendation"] === "true") {
    //   let id = [];
    //   for (let i = 0; i < this.data["customerIds"].length; i++) {
    //     id.push(this.data["customerIds"][i]["id"]);
    //   }
    //   this.dataForm.get("customerIds").setValue(id);
    // }
  }

  async getDefaultConfig(): Promise<void> {
    this.getDefaultConfigApi().then((res) => {
      console.log(res);
      if (res["body"]) {
        this.timeFrame =
          res["body"]["timeFrameConfig"]["MILESTONE_BASED_CHALLENGE"];
      }
    });
  }

  prefillData() {
    let data: ChallengeData = this.challengeDataServie.getChallengeDetails();
    let usageConfig: usageConfig = data?.usageConfig
      ? this.global.safeParse(data.usageConfig)
      : {};
    console.log(data);

    const audienceConfig = data?.audienceConfig
      ? this.global.safeParse(data.audienceConfig)
      : {};
    const timeFrame = data?.timeframe
      ? this.global.safeParse(data.timeframe)
      : {};
    this.dataForm
      .get("name")
      .setValue(this.convertMarkdownToHtml(data["challengeName"]));
    this.dataForm
      .get("description")
      .setValue(this.convertMarkdownToHtml(data["description"]));
    this.dataForm
      .get("header")
      .setValue(this.convertMarkdownToHtml(data["challengeHeading"] || data["challengeHeader"]));
    this.dataForm
      .get("aliasName")
      .setValue(this.convertMarkdownToHtml(data?.aliasChallengeName));
    this.dataForm
      .get("aliasDescription")
      .setValue(this.convertMarkdownToHtml(data?.aliasDescription));
    this.totalCustomerCount = audienceConfig?.customerCount;
    this.toggleDisabledValue();
    this.customerSegments = []; // Initialize as empty array

    // Collect matching segments for segmentIds, tierIds, customerListIds, employeeListIds
    const segmentSources = [
      "segmentIds",
      "tierIds",
      "customerListIds",
      "employeeListIds"
    ];
    
    segmentSources.forEach((sourceKey) => {
      const ids = audienceConfig[sourceKey];
      if (ids?.length > 0) {
        const matchedSegments = ids
          .map((id) => this.data.segments.find((segment) => segment.id === id))
          .filter(Boolean);
        this.customerSegments.push(...matchedSegments);
      }
    });
    
    // Excluded Segments
    if (audienceConfig["excludedSegments"]?.length > 0) {
      this.excludedSegments = [...audienceConfig["excludedSegments"]];
    } else {
      this.excludedSegments = [];
    }
    
    // Handle special flags
    if (audienceConfig["allLead"] === true) {
      this.customerSegments.push("LEADS");
    }
    if (audienceConfig["allCustomer"] === true) {
      this.customerSegments.push("ALL");
    }
    
    this.getCustomerCountInSegmentAndTiers();

    // this.offerBudgetData.redemptionCount = this.data.offerBudgetData.redemptionCount;
    // this.offerBudgetData.hasBudgetLimit = this.data.offerBudgetData.hasBudgetLimit;
    // this.offerBudgetData.resetFrequency = this.data.offerBudgetData.resetFrequency;

    this.timeBasedData.startDate.setValue(data.scheduledStartTime);
    this.timeBasedData.endDate.setValue(data.scheduledEndTime);
    this.timeBasedData.startTime.setValue(data.scheduledStartTime);
    this.timeBasedData.endTime.setValue(data.scheduledEndTime);

    // this.timeBasedData.anyTimeOftheDay = this.data.atAnyTime;
    // this.timeBasedData.everyDaySliderValue = this.data.everyDay;
    // this.timeBasedData.arrayDynamic = this.data.daysList;
    this.numberOfDays = timeFrame?.value ? timeFrame.value : null;
    this.usageLimit = usageConfig?.participationLimit;
    this.rejoiningDays = usageConfig?.rejoinInDays;
    this.timeFrameType = timeFrame?.type ? timeFrame.type : "CUSTOM";
    this.bannerImageUrl = data.bannerImage;
    this.badgeImageUrl = data.challengeImage;
    this.needsOptIn = data.needsOptIn;
  }

  async getSegments(): Promise<void> {
    await this.apiCallService
      .getCustomerSegmentsAndTiers()
      .subscribe((response) => {
        if (response["body"]) {
          this.data.segments = response["body"];
          if (this.isEdit) {
            this.prefillData();
          }
        }
      });
  }

  ngAfterViewInit() {
    document
      .getElementById("form-container")
      .addEventListener("click", (event) => this.hideAllEvents(event));
  }

  async getScreenId() {
    this.validScreens = await this._WidgetConfigService.getScreen();
    let index = this.validScreens?.findIndex((d) => d === 57);
    if (index === -1) {
      this.allcustomerObj = this.allcustomerObj.filter(
        (item) => item.id !== "LEADS"
      );
    }
  }

  hideAllEvents(event) {
    //for inclusion dropdown
    let includeDropdown = document.getElementById("multi-select-dropdown");
    let includeKeyboardIcon = document.getElementById(
      "keyboard-down-icon-container"
    );

    //for exclusion dropdown
    let excludeDropdown = document.getElementById("exclude-select-dropdown");
    let excludeKeyboardIcon = document.getElementById(
      "keyboard-down-icon-container-2"
    );

    const isOutsideInclude = !includeDropdown?.contains(event.target);
    const isOutsideExclude = !excludeDropdown?.contains(event.target);

    if (this.includeDropDownStatus && isOutsideInclude) {
      this.includeDropDownStatus = false;
      includeDropdown.style.height = "0px";
      includeKeyboardIcon.style.transform = "rotate(0deg)";
      this.getCustomerCountInSegmentAndTiers();
    }

    if (this.excludeDropDownStatus && isOutsideExclude) {
      this.excludeDropDownStatus = false;
      excludeDropdown.style.height = "0px";
      excludeKeyboardIcon.style.transform = "rotate(0deg)";
      this.getCustomerCountInSegmentAndTiers();
    }
  }

  toggleDisabledValue() {
    for (
      let i = 0;
      i < this.dataForm.get("customerSegments").value.length;
      i++
    ) {
      if (this.dataForm.get("customerSegments").value[i] === "null") {
        this.disableCustomerSegments = true;
        let value = ["null"];
        this.dataForm.get("customerSegments").setValue(value);
        return;
      }
    }
    this.disableCustomerSegments = false;
  }

  toggleSelect(event, container: "include" | "exclude") {
    event.stopPropagation();
    let element = document.getElementById(
      container === "include"
        ? "multi-select-dropdown"
        : "exclude-select-dropdown"
    );
    let segmentSelect = document.getElementById(
      container === "include" ? "segment-select" : "exclude-select"
    );
    let segmentSelectPanel = document.getElementById(
      container === "include"
        ? "multi-select-panel-challenge"
        : "exclude-select-panel-challenge"
    );
    let keyboardDownIconElement = document.getElementById(
      container === "include"
        ? "keyboard-down-icon-container"
        : "keyboard-down-icon-container-2"
    );
    if (container === "include" && this.excludeDropDownStatus) {
      this.closeDropdown("exclude");
    } else if (container === "exclude" && this.includeDropDownStatus) {
      this.closeDropdown("include");
    }

    if (container === "include") {
      this.includeDropDownStatus = !this.includeDropDownStatus;
      this.updateDropdownStyles(
        this.includeDropDownStatus,
        element,
        segmentSelect,
        segmentSelectPanel,
        keyboardDownIconElement
      );
    } else {
      this.excludeDropDownStatus = !this.excludeDropDownStatus;
      this.updateDropdownStyles(
        this.excludeDropDownStatus,
        element,
        segmentSelect,
        segmentSelectPanel,
        keyboardDownIconElement
      );
    }
    if (!this.includeDropDownStatus && !this.excludeDropDownStatus) {
      this.getCustomerCountInSegmentAndTiers();
    }
  }

  closeDropdown(container: "include" | "exclude") {
    let element = document.getElementById(
      container === "include"
        ? "multi-select-dropdown"
        : "exclude-select-dropdown"
    );
    let segmentSelect = document.getElementById(
      container === "include" ? "segment-select" : "exclude-select"
    );
    let segmentSelectPanel = document.getElementById(
      container === "include"
        ? "multi-select-panel-challenge"
        : "exclude-select-panel-challenge"
    );
    let keyboardDownIconElement = document.getElementById(
      container === "include"
        ? "keyboard-down-icon-container"
        : "keyboard-down-icon-container-2"
    );
    if (container === "include") {
      this.includeDropDownStatus = false;
    } else {
      this.excludeDropDownStatus = false;
    }
    this.updateDropdownStyles(
      false,
      element,
      segmentSelect,
      segmentSelectPanel,
      keyboardDownIconElement
    );
  }

  updateDropdownStyles(
    isOpen: boolean,
    element,
    segmentSelect,
    segmentSelectPanel,
    keyboardDownIconElement
  ) {
    if (isOpen) {
      element.style.height = "180px";
      segmentSelect.style.overflow = "auto";
      segmentSelectPanel.style.boxShadow = "0px 1px 6px 0px #25a7f9";
      segmentSelectPanel.style.border = "1px solid #25a7f9";
      keyboardDownIconElement.style.transform = "rotate(180deg)";
    } else {
      element.style.height = "0px";
      segmentSelect.style.overflow = "hidden";
      segmentSelectPanel.style.boxShadow = "unset";
      segmentSelectPanel.style.border = "1px solid #919191";
      keyboardDownIconElement.style.transform = "rotate(0deg)";
    }
  }

  updateCheckboxValues(segment, category) {
    document.getElementById("errorField").innerHTML = "";
    if (this.customerSegments.includes("ALL")) {
      if (this.customerSegments.includes("LEADS")) {
        this.customerSegments = [];
        this.customerSegments.push("LEADS");
      } else this.customerSegments = [];
    }
    let index = this.customerSegments.findIndex(
      (x) => x.id === segment.id && x.category.toLowerCase() === category
    );
    if (index < 0) {
      this.customerSegments.push(segment);
    } else {
      this.customerSegments.splice(index, 1);
    }
  }

  excludeSegment(segment, category) {
    let index = this.excludedSegments.findIndex(
      (x) => x.id === segment.id && x.category.toLowerCase() === category
    );
    if (index < 0) {
      this.excludedSegments.push(segment);
    } else {
      this.excludedSegments.splice(index, 1);
    }
  }

  checkboxStatus(segment) {
    let index = this.customerSegments.findIndex((x) => x.id === segment.id);
    if (index > -1) {
      return true;
    } else {
      return false;
    }
  }

  submitDashboardFilter() {
    this.startDateMaxValue = this.endDate.value;
    this.endDateMinValue = this.startDate.value;
  }

  getCustomerCountInSegmentAndTiers() {
    // if (this.customerSegments.length === 0) {
    //   this.totalCustomerCount = 0;
    //   this.totalCustomersValidEmail = 0;
    //   this.totalCustomersValidPhNo = 0;
    // } else {
    this.totalCustomerCount = 0;
    this.totalCustomersValidEmail = 0;
    this.totalCustomersValidPhNo = 0;
    this.storeTargetedCustomerCount = 0;
    if (
      this.customerSegments.includes("ALL") ||
      this.customerSegments.includes("LEADS")
    ) {
      let startDate = new Date();
      let endDate = new Date();
      let isLead = this.customerSegments.includes("LEADS") ? true : false;
      let isCustomer = this.customerSegments.includes("ALL") ? true : false;
      this.apiCallService
        .getAnalytics(
          startDate,
          endDate,
          isLead,
          isCustomer,
          null,
          this.excludedSegments
        )
        .subscribe((response) => {
          const responseBody = JSON.parse(response["body"]);
          this.totalCustomerCount =
            this.totalCustomerCount + responseBody.numberOfCustomers;
          this.storeTargetedCustomerCount =
            this.storeTargetedCustomerCount + responseBody.numberOfCustomers;
          this.totalCustomersValidEmail =
            this.totalCustomersValidEmail + responseBody.ValidEmailCount;
          this.totalCustomersValidPhNo =
            this.totalCustomersValidPhNo + responseBody.ValidMobileNumberCount;
        });
    }
    // if (this.customerSegments.includes("LEADS")) {
    //   let startDate = new Date();
    //   let endDate = new Date();
    //   this.apiCallService
    //     .getAnalytics(startDate, endDate, true)
    //     .subscribe((response) => {
    //       const responseBody = JSON.parse(response["body"]);
    //       this.totalCustomerCount =
    //         this.totalCustomerCount + responseBody.numberOfCustomers;
    //       this.totalCustomersValidEmail =
    //         this.totalCustomersValidEmail + responseBody.ValidEmailCount;
    //       this.totalCustomersValidPhNo =
    //         this.totalCustomersValidPhNo + responseBody.ValidMobileNumberCount;
    //     });
    // }
    if (this.isSegmentPresentArray(this.customerSegments)) {
      this.apiCallService
        .getCustomerCountInSegmentAndTiers(
          this.getOnlySegments(this.customerSegments),
          this.excludedSegments
        )
        .subscribe((response) => {
          const responseBody = JSON.parse(response["body"]);
          this.totalCustomerCount =
            this.totalCustomerCount + responseBody.totalCustomerCount;
          this.storeTargetedCustomerCount =
            this.storeTargetedCustomerCount +
            responseBody.targetedCustomerCount;
          this.totalCustomersValidEmail =
            this.totalCustomersValidEmail +
            responseBody.totalCustomerValidEmailCount;
          this.totalCustomersValidPhNo =
            this.totalCustomersValidPhNo +
            responseBody.totalCustomerValidSMSCount;
        });
    }
    // }
  }

  isSegmentPresentArray(dataArray) {
    return dataArray.some(
      (item) => typeof item === "object" && item !== null && "id" in item
    );
  }

  addAllCustomers(event, id) {
    document.getElementById("errorField").innerHTML = "";
    if (id === "ALL") {
      if (this.customerSegments.includes("LEADS")) {
        this.customerSegments = [];
        this.customerSegments.push("LEADS");
      } else this.customerSegments = [];
    }
    if (id === "LEADS") {
      let index = this.customerSegments.indexOf("LEADS");
      if (index < 0) {
        this.customerSegments.push(id);
      } else {
        this.customerSegments.splice(index, 1);
      }
    }
    if (event["checked"] === true && id === "ALL") {
      this.customerSegments.push(id);
    }
  }

  isChecked(segment, category, segmentList) {
    if (segmentList.includes("ALL")) {
      return false;
    } else {
      let index = segmentList.findIndex(
        (x) => x.id === segment.id && x.category.toLowerCase() === category
      );
      if (index > -1) {
        return true;
      } else {
        return false;
      }
    }
  }

  isIncluded(segment, category) {
    return this.isChecked(segment, category, this.customerSegments);
  }

  isExcluded(segment, category) {
    return this.isChecked(segment, category, this.excludedSegments);
  }

  isStoreCreated(segment) {
    return segment.createdBy?.storeId === this.storeId;
  }

  getSearchFilteredSegments() {
    return (this.data.segments as any[]).filter((segment) =>
      this.segmentFilter
        ? segment["segmentName"]
            .toLowerCase()
            .includes(this.segmentFilter.toLowerCase())
        : true
    );
  }

  getSearchFilteredExcludedSegments() {
    return (this.data.segments as any[]).filter((segment) =>
      this.excludeSegmentFilter
        ? segment["segmentName"]
            .toLowerCase()
            .includes(this.excludeSegmentFilter.toLowerCase())
        : true
    );
  }

  isSegmentPresent() {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) => segment.category.toLowerCase() === "segment"
        )
      );
    }
    return false;
  }
  isTierSegmentPresent(): boolean {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) => segment.category.toLowerCase() === "tier"
        )
      );
    }
    return false;
  }

  isCustomerListPresent(): boolean {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) => segment.category.toLowerCase() === "customerlist"
        )
      );
    }
    return false;
  }

  isStoreCustomerListPresent() {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) =>
            segment.category.toLowerCase() === "customerlist" &&
            this.isStoreCreated(segment)
        )
      );
    }
    return false;
  }

  isOtherCustomerListPresent() {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) =>
            segment.category.toLowerCase() === "customerlist" &&
            !this.isStoreCreated(segment)
        )
      );
    }
    return false;
  }

  isStoreSegmentsPresent() {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) =>
            segment.category.toLowerCase() === "segment" &&
            this.isStoreCreated(segment)
        )
      );
    }
    return false;
  }

  isOtherSegmentsPresent() {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) =>
            segment.category.toLowerCase() === "segment" &&
            !this.isStoreCreated(segment)
        )
      );
    }
    return false;
  }

  isEmployeeListPresent(): boolean {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) => segment.category.toLowerCase() === "employeelist"
        )
      );
    }
    return false;
  }

  exc;

  isSegmentPresent2() {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredExcludedSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) => segment.category.toLowerCase() === "segment"
        )
      );
    }
    return false;
  }
  isTierSegmentPresent2(): boolean {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredExcludedSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) => segment.category.toLowerCase() === "tier"
        )
      );
    }
    return false;
  }

  isCustomerListPresent2(): boolean {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredExcludedSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) => segment.category.toLowerCase() === "customerlist"
        )
      );
    }
    return false;
  }

  isStoreCustomerListPresent2() {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredExcludedSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) =>
            segment.category.toLowerCase() === "customerlist" &&
            this.isStoreCreated(segment)
        )
      );
    }
    return false;
  }

  isOtherCustomerListPresent2() {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredExcludedSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) =>
            segment.category.toLowerCase() === "customerlist" &&
            !this.isStoreCreated(segment)
        )
      );
    }
    return false;
  }

  isStoreSegmentsPresent2() {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredExcludedSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) =>
            segment.category.toLowerCase() === "segment" &&
            this.isStoreCreated(segment)
        )
      );
    }
    return false;
  }

  isOtherSegmentsPresent2() {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredExcludedSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) =>
            segment.category.toLowerCase() === "segment" &&
            !this.isStoreCreated(segment)
        )
      );
    }
    return false;
  }

  isEmployeeListPresent2(): boolean {
    if (this.data && this.data.segments) {
      const filteredSegments = this.getSearchFilteredExcludedSegments();
      return (
        filteredSegments.length > 0 &&
        filteredSegments.some(
          (segment) => segment.category.toLowerCase() === "employeelist"
        )
      );
    }
    return false;
  }

  getParticularStoreJSON() {
    let data: any = {};
    this.apiCallService.getSpecificStoreOffer().subscribe((response) => {
      console.log(response);
      data.storeId = response["body"]["storeMetaInfo"].storeId;
      data.storeName = response["body"]["storeMetaInfo"].storeName;
      data.qid = response["body"]["storeMetaInfo"].qid;
      data.userName = this.tokenStorage.getUsernameFull();
      data.userEmail = this.tokenStorage.getMerchantUserEmail();
      this.storeDataJSON = data;
    });
  }

  stringInputHandler(event: KeyboardEvent, maxLength: number, type: string) {
    if (this.duplicateNameErrorText) this.duplicateNameErrorText = "";

    // Allow Ctrl/Command + A, C, X, V, and Arrow keys
    if (
      (event.ctrlKey || event.metaKey) &&
      ["a", "c", "x", "v"].includes(event.key.toLowerCase())
    ) {
      return; // Allow these actions
    }

    // Get the value inside ngx-editor
    const control = this.dataForm.get(type);
    if (!control) return;

    const inputValue = control.value || "";
    if (inputValue?.replace(/<\/?[^>]+(>|$)/g, "").length > 1) {
      const clearError = (id: string) => {
        const el = document.getElementById(id);
        if (el) el.innerHTML = "";
      };

      // Clear previous errors
      if (type == "name") {
        clearError("name-error");
      }
      if (type == "aliasName") {
        clearError("aliasName-error");
      }
    }

    // Prevent input if max length is reached (except for Backspace)
    if (
      inputValue?.replace(/<\/?[^>]+(>|$)/g, "").length >= maxLength &&
      event.key !== "Backspace"
    ) {
      event.preventDefault();
      return false;
    }
  }

  stringInputKeyDown(event: KeyboardEvent, maxLength, comparisonStatement?) {
    if (this.duplicateNameErrorText) this.duplicateNameErrorText = "";
    // Allow Ctrl/Command + A, Ctrl/Command + C, Ctrl/Command + X, and Arrow keys
    if (
      (event.ctrlKey || event.metaKey) &&
      ["a", "c", "x", "v"].includes(event.key.toLowerCase())
    ) {
      return; // Allow these actions
    }
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length >= maxLength && event.key !== "Backspace") {
      event.preventDefault();
    }
  }

  stringNumberInputKeyDown(
    event: KeyboardEvent,
    maxLength: number,
    comparisonStatement?
  ) {
    if (this.duplicateNameErrorText) this.duplicateNameErrorText = "";

    const allowedKeys = [
      "Backspace",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
      "Delete",
    ];

    // Allow Ctrl/Command + A, C, X, V
    if (
      (event.ctrlKey || event.metaKey) &&
      ["a", "c", "x", "v"].includes(event.key.toLowerCase())
    ) {
      return;
    }

    const key = event.key;

    // Allow only digits and allowed control keys
    if (!/^\d$/.test(key) && !allowedKeys.includes(key)) {
      event.preventDefault();
      return;
    }

    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length >= maxLength && key !== "Backspace") {
      event.preventDefault();
    }
  }

  removeErrorMsg(event) {
    if (this.rejoiningDays !== 0 && this.rejoiningDays !== null)
      document.getElementById("rejoiningDateErrorField").innerHTML = "";
    if (this.usageLimit !== 0 && this.usageLimit !== null)
      document.getElementById("numberofTimeErrorField").innerHTML = "";
    if (
      this.timeFrameType === "CUSTOM" &&
      this.needsOptIn &&
      (this.numberOfDays !== 0 || this.numberOfDays !== null)
    )
      document.getElementById("numberDaysErrorField").innerHTML = "";
  }

  getCountOfText(value: string) {
    return value?.replace(/<\/?[^>]+(>|$)/g, "").length || 0;
  }

  getOnlySegments(data) {
    const temp = [...data]; // Create a shallow copy of the array
    let index1 = temp.indexOf("LEADS");
    let index2 = temp.indexOf("ALL");

    if (index1 !== -1) {
      temp.splice(index1, 1);
    }
    // Recalculate index2 after modifying the array
    index2 = temp.indexOf("ALL");
    if (index2 !== -1) {
      temp.splice(index2, 1);
    }

    return temp;
  }

  setUploadedFile(event, imageType) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      console.warn("No file selected.");
      return;
    }
    if (imageType == "CHALLENGE") {
      this.uploading1 = true;
    }
    if (imageType == "BANNER") {
      this.uploading2 = true;
    }
    const fd = new FormData();
    fd.append("files", event.target.files[0], event.target.files[0].name);
    this.apiCallService.uploadChallengeImage(fd, imageType).subscribe(
      (response) => {
        // console.log('Response received:', response);
        if (imageType === "CHALLENGE") {
          this.uploading1 = false;
          this.badgeImageUrl = response["body"][0] + "?v=" + Date.now();
        }
        if (imageType === "BANNER") {
          this.uploading2 = false;
          this.bannerImageUrl = response["body"][0] + "?v=" + Date.now();
        }
      },
      (error) => {
        this._snackBar.openSnackBar("Error uploading image", 2000);
        this.uploading1 = false;
      }
    );
  }

  selectChallengeType(value) {
    let apiDataFormat: ChallengeData;
    if (value === "create" || value === "saveandexit") {
      let segments = [];
      let tiers = [];
      let customerList = [];
      let employeeList = [];
      let excludedSegments = [];
      let excludedTiers = [];
      let excludedCustomerList = [];
      let excludedEmployeeList = [];
      if (!this.customerSegments.includes("ALL")) {
        this.customerSegments.map((x) => {
          if (x?.category?.toLowerCase() === "segment") {
            segments.push(x.id);
          }
          if (x?.category?.toLowerCase() === "tier") {
            tiers.push(x.id);
          }
          if (x?.category?.toLowerCase() === "customerlist") {
            customerList.push(x.id);
          }
          if (x?.category?.toLowerCase() === "employeelist") {
            employeeList.push(x.id);
          }
        });
      }

      this.excludedSegments.map((x) => {
        if (x?.category?.toLowerCase() === "segment") {
          excludedSegments.push(x.id);
        }
        if (x?.category?.toLowerCase() === "tier") {
          excludedTiers.push(x.id);
        }
        if (x?.category?.toLowerCase() === "customerlist") {
          excludedCustomerList.push(x.id);
        }
        if (x?.category?.toLowerCase() === "employeelist") {
          excludedEmployeeList.push(x.id);
        }
      });
      let audienceConfig = {};
      audienceConfig["tierIds"] = tiers;
      audienceConfig["segmentIds"] = segments;
      audienceConfig["customerListIds"] = customerList;
      audienceConfig["employeeListIds"] = employeeList;
      audienceConfig["excludedSegments"] = excludedSegments;
      audienceConfig["excludedTiers"] = excludedTiers;
      audienceConfig["excludedCustomerList"] = excludedCustomerList;
      audienceConfig["excludedEmployeeList"] = excludedEmployeeList;
      audienceConfig["allLead"] = this.customerSegments.includes("LEADS")
        ? true
        : false;
      audienceConfig["allCustomer"] = this.customerSegments.includes("ALL")
        ? true
        : false;
      audienceConfig["totalCustomerSize"] = this.totalCustomerCount;

      let timeFrame = {
        type: this.timeFrameType,
        value: this.numberOfDays,
      };

      apiDataFormat = {
        id: null,
        challengeName: this.convertBoldToMarkdown(
          this.dataForm.get("name").value
        ),
        aliasChallengeName: this.convertBoldToMarkdown(
          this.dataForm.get("aliasName").value
        ),
        challengeHeading: this.convertBoldToMarkdown(
          this.dataForm.get("header").value
        ),
        challengeType: null,
        description: this.convertBoldToMarkdown(
          this.dataForm.get("description").value
        ),
        aliasDescription: this.convertBoldToMarkdown(
          this.dataForm.get("aliasDescription").value
        ),
        scheduledStartTime: this.timeBasedData.toTimeFormat(
          this.timeBasedData.startDate.value
        ),
        scheduledEndTime: this.timeBasedData.toTimeFormat(
          this.timeBasedData.endDate.value
        ),
        challengeImage: this.badgeImageUrl ? this.badgeImageUrl : "",
        bannerImage: this.bannerImageUrl ? this.bannerImageUrl : "",
        timeframe: this.needsOptIn ? JSON.stringify(timeFrame) : null,
        audienceConfig: JSON.stringify(audienceConfig),
        startNodeId: null,
        usageConfig: JSON.stringify({
          participationLimit: this.usageLimit,
          rejoinInDays: this.rejoiningDays,
        }),
        totalMilestones: this.getMilestoneCount(
          this.challengeDataServie.getMilestoneConfig()
            ? this.challengeDataServie.getMilestoneConfig()
            : []
        ),
        needsOptIn: this.needsOptIn,
        status: this.isEdit
          ? this.challengeDataServie?.getChallengeDetails()["status"]
          : "DRAFT",
        displayParams: this.challengeDataServie.getMilestoneConfig()
          ? JSON.stringify(this.challengeDataServie.getMilestoneConfig())
          : "",
      };
    }
    let sendData = {
      value: value,
      data: apiDataFormat,
    };

    if (this.validateData() || value === "exit") {
      this.challengeDetails.emit(sendData);
    }
  }
  getMilestoneCount(data): number {
    if (!data || typeof data !== "object" || Object.keys(data).length === 0) {
      return 0;
    }
    return Array.isArray(data)
      ? data.filter((item) => item.type === "MILESTONECONFIG").length
      : 0;
  }

  stripHtmlTags(value: string): string {
    const doc = new DOMParser().parseFromString(value || "", "text/html");
    return doc.body.textContent || "";
  }

  cleanHtmlFromControl(field: string) {
    const control = this.dataForm.get(field);
    if (control && typeof control.value === "string") {
      const cleaned = this.stripHtmlTags(control.value);
      if (cleaned !== control.value) {
        control.setValue(cleaned, { emitEvent: false });
        control.markAsDirty();
        control.updateValueAndValidity();
      }
    }
  }

  validateData(): boolean {
    const englishOnlyRegex = /^(?!\s)[A-Za-z0-9\s.,'"<>\-()!?/_|]*$/;
    this.submitClicked = true;
    let isValid = true;

    // Cleaned versions of form values, without affecting dataForm
    const cleanedValues: Record<string, string> = {};
    const fieldsToClean = [
      "name",
      "aliasName",
      "description",
      "aliasDescription",
      "header",
    ];

    fieldsToClean.forEach((field) => {
      const control = this.dataForm.get(field);
      const rawValue = control?.value || "";
      cleanedValues[field] = this.stripHtmlTags(rawValue).trim(); // Clean without setting it in the form
    });

    // Now validate using cleanedValues instead of form.get('x').value
    const name = cleanedValues["name"];
    const aliasName = cleanedValues["aliasName"];
    const description = cleanedValues["description"];
    const aliasDescription = cleanedValues["aliasDescription"];
    const header = cleanedValues["header"];

    const clearError = (id: string) => {
      const el = document.getElementById(id);
      if (el) el.innerHTML = "";
    };

    // Clear previous errors
    clearError("name-error");
    clearError("aliasName-error");
    clearError("description-error");
    clearError("aliasDescription-error");
    clearError("header-error");
    clearError("errorField");
    clearError("numberDaysErrorField");
    clearError("numberofTimeErrorField");
    clearError("rejoiningDateErrorField");

    // Validate name
    if (
      !name ||
      name.length === 0 ||
      name.length < 3 ||
      name.length > 50 ||
      !englishOnlyRegex.test(name)
    ) {
      isValid = false;
      const msg =
        name.length > 50
          ? "Challenge name should not exceed 50 characters"
          : name.length === 0
          ? "Challenge name should not be empty"
          : name.length < 3
          ? "Challenge name should have at least 3 characters"
          : "Challenge name must contain only English characters, numbers, spaces, punctuation and underscores, and cannot start with a space.";

      document.getElementById("name-error")!.innerHTML =
        this._i18nDynamicTranslate.transform(msg, ["SHARED_PAGE"]);
    }

    // Validate aliasName
    if (
      aliasName.length > 50 ||
      (aliasName.length > 0 && aliasName.length < 3)
    ) {
      isValid = false;
      const msg =
        aliasName.length > 50
          ? "Alias Challenge name should not exceed 50 characters"
          : "Alias Challenge name should have at least 3 characters";

      document.getElementById("aliasName-error")!.innerHTML =
        this._i18nDynamicTranslate.transform(msg, ["SHARED_PAGE"]);
    }

    // Validate description
    if (
      description.length > 300 ||
      (description.length > 0 && !englishOnlyRegex.test(description))
    ) {
      isValid = false;
      const msg =
        description.length > 300
          ? "Challenge description should not exceed 300 characters"
          : "Challenge description must contain only English characters, numbers, spaces, punctuation and underscores, and cannot start with a space.";

      document.getElementById("description-error")!.innerHTML =
        this._i18nDynamicTranslate.transform(msg, ["SHARED_PAGE"]);
    }

    // Validate aliasDescription
    if (aliasDescription.length > 300) {
      isValid = false;
      document.getElementById("aliasDescription-error")!.innerHTML =
        this._i18nDynamicTranslate.transform(
          "Alias Challenge description should not exceed 300 characters",
          ["SHARED_PAGE"]
        );
    }

    if (
      header.length > 300 ||
      (header.length > 0 && !englishOnlyRegex.test(header))
    ) {
      isValid = false;
      const msg =
        header.length > 300
          ? "Header should not exceed 300 characters"
          : "Header must contain only English characters, numbers, spaces, punctuation and underscores, and cannot start with a space.";

      document.getElementById("header-error")!.innerHTML =
        this._i18nDynamicTranslate.transform(msg, ["SHARED_PAGE"]);
    }

    // Additional validations (no changes needed)
    if (this.customerSegments.length === 0) {
      isValid = false;
      document.getElementById("errorField")!.innerHTML =
        this._i18nDynamicTranslate.transform("Select any segment", [
          "SHARED_PAGE",
        ]);
      document.getElementById("multi-select-panel-challenge")!.style.border =
        "1px solid #c71a1a";
    }

    if (
      this.timeFrameType === "CUSTOM" &&
      this.needsOptIn &&
      (!this.numberOfDays || this.numberOfDays <= 0)
    ) {
      isValid = false;
      document.getElementById("numberDaysErrorField")!.innerHTML =
        this._i18nDynamicTranslate.transform(
          "Challenge completion time cannot be 0",
          ["SHARED_PAGE"]
        );
    }

    if (!this.usageLimit || this.usageLimit <= 0) {
      isValid = false;
      document.getElementById("numberofTimeErrorField")!.innerHTML =
        this._i18nDynamicTranslate.transform(
          "Participation Limit should be greater than 0",
          ["SHARED_PAGE"]
        );
    }

    if (!this.rejoiningDays || this.rejoiningDays <= 0) {
      isValid = false;
      document.getElementById("rejoiningDateErrorField")!.innerHTML =
        this._i18nDynamicTranslate.transform(
          "Rejoining Eligibility Period should be greater than 0",
          ["SHARED_PAGE"]
        );
    }

    return isValid;
  }

  convertBoldToMarkdown(html: string): string {
    return this.global.convertBoldToMarkdown(html);
  }

  convertMarkdownToHtml(markdown: string): string {
    return this.global.convertMarkdownToHtml(markdown);
  }

  onPaste(event: ClipboardEvent): void {
    console.log(event);
  }

  getDefaultConfigApi() {
    return new Promise((resolve, reject) => {
      this.apiCallService.getDefaultConfiguration().subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);

          reject(err.error);
        }
      );
    });
  }
}
